module.exports = __webpack_public_path__ + "static/img/3-2.d15a354.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-3/3-2.jpg
// module id = 737
// module chunks = 1